import useTooltip from "../../../hooks/useTooltip.tsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/pro-solid-svg-icons";

export default function IBookmarkedIndicator() {
  const tooltipRef = useTooltip<HTMLDivElement>();

  return (
    <div
      ref={tooltipRef}
      className="btn btn-sm text-muted"
      title={I18n.t("js.activitystreams.on_bookmark_list")}
    >
      <FontAwesomeIcon icon={faStar} />
    </div>
  );
}
